import React from 'react'
import { IIconProps } from './Icon/Interfaces'

const SendIcon = ({
  width=18,
  height=21,
  strokeColor='var(--blue)',
}: IIconProps) => {
  return (
    <svg fill="none" viewBox="0 0 18 21" height={height} width={width}>
      <path
        fill={strokeColor}
        d="m15.535 10.392.5.866 1.5-.866-1.5-.866-.5.866zM1 18.785H0v1.732l1.5-.866-.5-.866zM1 2l.5-.866L0 .268V2h1zm0 7.015H0v.727l.691.224.31-.951zm4.24 1.377.309.95 2.928-.95-2.929-.951-.308.95zM1 11.769l-.309-.952-.69.225v.726h1zm14.036-2.243L.5 17.92l1 1.732 14.536-8.393-1-1.732zM.5 2.866l14.536 8.392 1-1.732L1.5 1.134l-1 1.732zM2 9.015V2H0v7.015h2zm-1.31.951 4.24 1.377.618-1.902-4.24-1.377L.69 9.966zm4.24-.525L.69 10.817l.618 1.903 4.24-1.377L4.93 9.44zM2 18.785v-7.017H0v7.017h2z"
      />
    </svg>
  )
}

export default SendIcon
